import apiV2 from "api-v2";
import {
	rfxDownloadAllResponsesRoute,
	rfxDownloadPdfSummaryRoute,
	rfxDownloadSingleResponseRoute,
} from "helpers/api/apiRoutes";
import { downloadFileNoPopup } from "helpers/linkHelper";
import { ApiResponse } from "types/common.types";
import { FileableFile } from "types/storage.types";
import { logErrorIfDebug } from "utils/logging";

export const generatePdf = async (
	type: "summary" | "responses",
	rfxId: number,
	respondentId: number,
	isGuest: boolean
) => {
	try {
		let route;
		if (respondentId) {
			route = rfxDownloadSingleResponseRoute(rfxId, respondentId, isGuest);
		} else {
			route =
				type === "summary"
					? rfxDownloadPdfSummaryRoute(rfxId)
					: rfxDownloadAllResponsesRoute(rfxId);
		}
		await apiV2
			.get<ApiResponse<FileableFile>>(route, {
				timeout: 300000, // 5 minutes for this request only
			})
			.then((response) => {
				const url = response.data.data.file_path;
				downloadFileNoPopup(url);
			})
			.catch((ex) => {
				logErrorIfDebug(ex?.message);
			});
	} catch (error) {
		logErrorIfDebug("PDF Download error", error);
	}
};
